import { useState } from 'react';
import css from './Sections.module.css';
import classNames from 'classnames';
import Icons from '../../../components/Icons/Icons';
import { PrimaryButton } from '../../../components';

const SectionFAQ = props => {
  const { intl, viewport } = props;
  const [activeIndex, setActiveIndex] = useState(null);
  const faqs = [
    {
      questionId: '01. Create your Account',
      answer: () => (
        <div className={css.faqInfo}>
          <p>
            Sign up in under 60 seconds. Verify your email to activate your profile and start
            listing immediately.
          </p>
        </div>
      ),
    },
    {
      questionId: '02. Create a Listing',
      answer: () => (
        <div className={css.faqInfo}>
          <p>
            Upload a minimum of 3 photos showing all angles: soleplate, upper, and heel required.
            Select the size, condition, brand, and model from the dropdown menus.
          </p>
          <p>
            Set your asking price, or enable minimum offer values in your profile settings to
            control what offers you'll accept.
          </p>
          <p>
            Add a detailed description and note any defects honestly. Transparency builds trust and
            prevents disputes.
          </p>
        </div>
      ),
    },
    {
      questionId: '03. Publish Instantly',
      answer: () => (
        <div className={css.faqInfo}>
          <p>
            Your listing goes live immediately and becomes visible to thousands of players,
            collectors, and resellers in your region.{' '}
          </p>
        </div>
      ),
    },
    {
      questionId: '04. Offers & Sales',
      answer: () => (
        <div className={css.faqInfo}>
          <p>You'll receive offer notifications through your inbox.</p>

          <p>
            <strong>You can:</strong>
          </p>
          <ul>
            <li>→ Accept the offer</li>
            <li>→ Decline the offer</li>
            <li>→ Send a counter-offer</li>
          </ul>

          <p>
            When your item sells, you'll receive a New Order notification with shipping
            instructions. Choose your preferred shipping method in your profile settings:
          </p>
          <p>
            <strong> Option A — Rareboots Shipping (Recommended)</strong>
            <br /> We generate a pre-paid shipping label using Royal Mail or DPD. Simply print it,
            pack your boots securely, and drop them off.
          </p>
          <p>
            <strong>Option B — Manual Shipping</strong> <br />
            Handle shipping yourself and enter the tracking number on your order page once
            dispatched.
          </p>
          <p>
            <strong>All sellers must ship within 2 working days.</strong>
          </p>
        </div>
      ),
    },
    {
      questionId: '05. Delivery & Confirmation',
      answer: () => (
        <div className={css.faqInfo}>
          <p>
            The buyer has 48 hours to confirm they received the boots and they're happy with them.
            If they don't respond, the system automatically confirms delivery after 48 hours.
          </p>
          <p>
            <strong>If the buyer is happy: </strong> <br />
            They accept the order and funds are released to you immediately.
          </p>
          <p>
            <strong> If the buyer raises a dispute:</strong> <br />
            The Rareboots team steps in to analyze the evidence from both sides and makes a fair
            decision based on what's provided.
          </p>
          <p>
            <strong>
              You only get paid once the buyer confirms satisfaction or the 48-hour window expires.
            </strong>
            This keeps transactions secure for everyone.
          </p>
        </div>
      ),
    },
  ];

  const handleAccordionClick = index => {
    setActiveIndex(prev => (prev === index ? null : index)); // toggle
  };

  return (
    <div className={css.faqContent}>
      {faqs.map((faq, index) => (
        <div
          key={index}
          className={classNames(css.faqCard, {
            [css.activeFAQ]: activeIndex === index,
          })}
          onClick={() => handleAccordionClick(index)}
        >
          <div className={css.faqBody}>
            <span className={css.faqHeading}>{intl.formatMessage({ id: faq.questionId })} </span>{' '}
            {activeIndex === index && (
              <div className={css.faqDescription}>
                {faq.answerId ? intl.formatMessage({ id: faq.answerId }) : faq.answer()}
              </div>
            )}
          </div>
          <span className={css.faqIcon}>
            {activeIndex === index ? (
              <span>
                <Icons name="faqOpenIcon" />
              </span>
            ) : (
              <span>
                <Icons name="faqCloseIcon" />
              </span>
            )}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SectionFAQ;
